



























































import { Component, Vue, Prop, Watch,Emit } from 'vue-property-decorator';
@Component({})
export default class updateFile extends Vue {
    @Prop({ default: () => [] })
    value;
    @Prop({ default: true })
    upload;
    @Prop({ default: '' })
    title;
    @Prop({ default: '根据提示信息完善表格内容' })
    content;
    @Prop({ default: '' })
    public accept:string;
    @Prop({
        type:Object,
        default:()=>{
            return {}
        }
    })
    public dataoption:any
    @Prop({
        type:Boolean,
        default:false
    })
    public multiple:boolean
    public fileList:any = []
    mounted() {}
    async filechange(file) {
        const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
        const whiteList = ['xls', 'xlsx'];
        if (whiteList.indexOf(fileSuffix) === -1) {
          this.$message.error('上传文件只能是xls、xlsx格式');
          this.fileList = [];
          return;
        }

        this.fileList=[file];

    }
    downFile(url) {
        window.open(url, '_blank');
    }
    @Emit('close')
    public closeHandler(){
        this.fileList = []
        console.log('sssss');
        
        return false
    }
    @Emit('downloadExcel')
    public downloadExcel(){
       
    }
    @Emit('submitHandler')
    public submitHandler(){
      if(this.fileList.length==0){
        this.$message.warning("请先上传文件！");
        return;
      }
        this.fileList.map(v=>{
            this.value.push(v)
        })
        this.closeHandler();
    }
    delFile(file, fileList) {
        console.log('file, fileList',file, fileList)
        this.fileList = fileList
        // this.value.splice(i, 1);
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/updateFile.vue